import {
  DecomposedMetamodel,
  MetamodelHierarchy,
  MetamodelTypeName,
} from './types';
import {
  DEFAULT_METAMODEL_EDITOR_LABELS,
  MetamodelEditorLabels,
} from '../labels';

export const ROOT_ID = 'root';
export const decomposeMetamodel = (
  componentHierarchy: MetamodelHierarchy
): DecomposedMetamodel => {
  const metamodelTypes: DecomposedMetamodel['metamodelTypes'] = {};
  const hierarchy: DecomposedMetamodel['childrenIndexes'] = {
    [ROOT_ID]: Object.keys(componentHierarchy),
  };
  _decomposeMetamodel(componentHierarchy, hierarchy, metamodelTypes);
  return {
    metamodelTypes: metamodelTypes,
    childrenIndexes: hierarchy,
  };
};

const _decomposeMetamodel = (
  metamodelHierarchy: MetamodelHierarchy,
  hierarchy: DecomposedMetamodel['childrenIndexes'],
  metamodelTypes: DecomposedMetamodel['metamodelTypes']
) => {
  if (!metamodelHierarchy) return;
  Object.entries(metamodelHierarchy).forEach(([key, value]) => {
    hierarchy[key] = Object.keys(value.children);
    metamodelTypes[key] = value;
    _decomposeMetamodel(value.children, hierarchy, metamodelTypes);
  });
};

export const validateNameFromRecord = (
  metamodelTypes: DecomposedMetamodel['metamodelTypes'],
  metamodelType: MetamodelTypeName,
  labels: Pick<
    MetamodelEditorLabels,
    'validationNameEmpty' | 'validationNameTaken'
  > = DEFAULT_METAMODEL_EDITOR_LABELS
) => {
  const newName = metamodelType.name?.trim();
  const id = metamodelType.id;
  if (!newName || newName === '') {
    throw new Error(labels.validationNameEmpty);
  }
  const isNameTaken = Object.values(metamodelTypes).some(
    ({ name, id: modelTypeId }) =>
      modelTypeId !== id && newName.toLowerCase() === name.toLowerCase()
  );
  if (isNameTaken) {
    throw new Error(labels.validationNameTaken);
  }
};

export const getDescendants = (
  childrenMap: Record<string, string[]>,
  id: string
): string[] => {
  const children = childrenMap[id] || ([] as string[]);
  return [
    ...children,
    ...children.flatMap(childId => getDescendants(childrenMap, childId)),
  ];
};
